import Skeleton from 'react-loading-skeleton';

import { TableBuilder } from '../../../cdl/TableBuilder/TableBuilder';
import { TableBuilderColumn } from '../../../cdl/TableBuilder/TableBuilderColumn';
import { translate } from '../../../common/helpers/translate.helper';

export const ProcessingVesselProductsTable = () => {
    const skeletonRows = Array.from({ length: 20 }, (_, i) => i);

    return (
        <TableBuilder data={skeletonRows} grow={false}>
            <TableBuilderColumn header={translate('vessel.products.productName')} width="25%" truncate>
                {() => <Skeleton height={16} width="70%" />}
            </TableBuilderColumn>
            <TableBuilderColumn header={translate('vessel.products.supplierName')} width="15%">
                {() => <Skeleton height={16} width="60%" />}
            </TableBuilderColumn>
            <TableBuilderColumn header={translate('vessel.products.productGroup')} width="15%">
                {() => <Skeleton height={16} width="50%" />}
            </TableBuilderColumn>
            <TableBuilderColumn header={translate('vessel.products.dateCreated')} width="10%">
                {() => <Skeleton height={16} width="80%" />}
            </TableBuilderColumn>
            <TableBuilderColumn header={translate('vessel.products.dateUpdated')} width="15%">
                {() => <Skeleton height={16} width="80%" />}
            </TableBuilderColumn>
            <TableBuilderColumn header={translate('vessel.products.note')} width="20%" truncate>
                {() => <Skeleton height={16} width="90%" />}
            </TableBuilderColumn>
        </TableBuilder>
    );
};
